import { useEffect } from 'react';

export interface PageMetaProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  ogType?: string;
  articlePublishedTime?: string;
  articleModifiedTime?: string;
  articleAuthor?: string;
  articleSection?: string;
}

export default function PageMeta(props: PageMetaProps) {
  useEffect(() => {
    const originalTitle = document.title;
    document.title = props.title;

    const setMeta = (name: string, content: string | undefined, isProperty = false) => {
      if (!content) return;
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', props.description);
    setMeta('keywords', props.keywords);

    if (props.canonicalUrl) {
      let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!link) {
        link = document.createElement('link');
        link.rel = 'canonical';
        document.head.appendChild(link);
      }
      link.href = props.canonicalUrl;
    }

    setMeta('og:title', props.ogTitle || props.title, true);
    setMeta('og:description', props.ogDescription || props.description, true);
    setMeta('og:type', props.ogType || 'website', true);
    setMeta('og:image', props.ogImage, true);
    if (props.canonicalUrl) {
      setMeta('og:url', props.canonicalUrl, true);
    }

    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', props.ogTitle || props.title);
    setMeta('twitter:description', props.ogDescription || props.description);
    setMeta('twitter:image', props.ogImage);

    if (props.articlePublishedTime) {
      setMeta('article:published_time', props.articlePublishedTime, true);
    }
    if (props.articleModifiedTime) {
      setMeta('article:modified_time', props.articleModifiedTime, true);
    }
    if (props.articleAuthor) {
      setMeta('article:author', props.articleAuthor, true);
    }
    if (props.articleSection) {
      setMeta('article:section', props.articleSection, true);
    }

    return () => {
      document.title = originalTitle;
    };
  }, [props]);

  return null;
}